module.exports = "<div class=\"m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop\n m-grid--desktop m-container m-container--responsive m-container--xxl m-container--full-height\" style=\"background: #fafbfc\">\n\t<div class=\"m-grid__item m-grid__item--fluid m-wrapper\">\n\t\t<router-outlet></router-outlet>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/portalV2/default/default.component.html
// module id = ./src/app/portalV2/default/default.component.html
// module chunks = main